<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <div class="mr-2">
          <b-button
            v-b-tooltip.hover.right="$t('Register Discount')"
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="outline-success"
            @click="openClientModal"
          >
            <div class="d-flex justify-content-between">
              <span> {{ $t("CREATE") }} </span>
            </div>
          </b-button>
        </div> 
      </template>
    </header-slot>
    <!-- <b-nav card-header pills class="m-0">
      <b-nav-item
        v-for="(item, index) in tabs"
        :key="index"
        :to="{ name: item.name }"
        exact
        exact-active-class="active"
        :link-classes="['px-3', bgTabsNavs]"
        >{{ $t(item.title) }}
      </b-nav-item>
    </b-nav> -->
    <b-card
      no-body
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <!-- <router-view ref="routerViewTab" :key="routeName" /> -->
        <ClientsTable ref="refClientTable" />
    </b-card>
  </div>
</template>

<script>
import Ripple from "vue-ripple-directive";
import ClientsTable from "@/views/commons/clients/components/ClientsTable.vue";
export default {
    components:{
        ClientsTable,
    },
    directives:{
        Ripple,
    },
    methods:{
        openClientModal(){
            this.$refs.refClientTable.newClient();
        }
    }
};
</script>

<style>
</style>